@if (!dismissed()) {
  <div
    class="relative z-20 flex min-h-[35px] items-center justify-center border-b border-solid px-9 py-3 font-medium md:px-10"
    [class]="containerClass()"
  >
    <span class="inline-block max-w-full text-balance text-center leading-snug">
      @if (bannerConfig(); as config) {
        <dojo-icon class="-mt-0.5 mr-1 inline-block align-middle leading-none" [icon]="config.icon" [size]="14" />
      }
      @if (isHtml()) {
        <span class="align-middle" [innerHTML]="bannerMessage()"></span>
      } @else {
        {{ bannerMessage() }}
      }
    </span>

    @if (isDismissible()) {
      <dojo-icon-button
        class="absolute right-1 md:right-2"
        [icon]="'xmark'"
        [size]="'xs'"
        [transparent]="true"
        (click)="dismiss()"
      />
    }
  </div>
}
